import api from "shared/infra/services/api";
import { EmailTokenConfirmationData } from "shared/providers/context/types/auth-context";

const emailTokenConfirmation = async (token: EmailTokenConfirmationData) => {
  const response = await api.post("user/confirm", { token });
  return response?.data;
};

export default emailTokenConfirmation;
